import gql from 'graphql-tag'

export const fragment = gql`
fragment listBills on BillConnection {
	items {
    id
    isCancelled
    dateTime
    number
    total
    eft
    rfid
    cashRegister {
    	parameters {
    		creditCards {
          clientButtonName {
            position
            value
          }
        }
    	}
    }
    user {
      name
      code
    }
  }
  totalAmount
  cursors {
		hasNext
		hasPrevious
		before
		after
	}
}
`

const query = gql`
query listBills($params: ListQueryArgs, $filter: BillFilterArgs) {
	cashAssist {
		listBills(params: $params, filterAndOp: $filter) {
			...listBills
		}
	}
}
${fragment}`

export default query
